import BaseDB from 'libs/DB/BaseDB'

const dataDB = new BaseDB('orgChartDB', {
  version: 1,
  key: 'id',
  expireDuration: null,
  checkForList: (item, key) => {
    if (typeof key === 'number' || key.indexOf('info') !== 0) {
      return true
    }
    return false
  },
})

export default dataDB
